import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import { PaymentMethodTypeNoPayProps } from './PaymentMethodDisplay.types'
import * as S from './PaymentMethodDisplay.styles'

const PaymentMethodTypeNoPay = ({
  className = ''
}: PaymentMethodTypeNoPayProps) => {
  const { formatMessage } = useIntl()

  return (
    <div className={twMerge(S.PaymentMethodDisplayWrapper, className)}>
      <div className={S.PaymentMethodDisplayContentWrapper}>
        {formatMessage({
          id: 'msp.checkout.confirmation.paymentMethod.noPay',
          defaultMessage: 'No payment necessary'
        })}
      </div>
    </div>
  )
}

export default PaymentMethodTypeNoPay
